// @flow
import compose from 'lodash/flowRight'

import Header from './Header'
import redux from './redux'

export default compose(redux)(Header)
